import supreme from "../supreme";
import {getTimestamp,getQueryString} from "../util/util";
import taskMgr from "./taskMgr";
import taskStack from './taskStack'
/**
 *@desc 跳转回退集中管理对象
 *@author lei.you
 *@date 2018/02/08
 * */
export  default{
  //是否初始化
  hasInitlized:false,
  $router:null,
  defaultJumpPath:"/",
  // 页面刷新式加载，不是通过单页模式的加载
  jump(){

  },
  forward(pathName, params = {}){
    var paramsStr="";
    if (!supreme.$.isEmptyObject(params)) {
      paramsStr = supreme.$.param(params);
    }
    this.$router.push(pathName + "?" + paramsStr)
  },
  /**
   * @ params .useCache 动态指定下个页面是否使用缓存
   *
   * */
  goto(pathName, params = {}) {
    if (!this.$router) {
      throw "use this function must has vue router module";
      return;
    }
    var router = this.$route;
    params.url_gid = getTimestamp();
    params.isForward = true;
    var p={
      pathName:pathName,
      params:params
    }
    var task = taskMgr.add(p);
    if(params.useCache!=undefined){
      this._useCache(task,params.useCache);
    }
    supreme._isPopState=false;
    if (!supreme.$.isEmptyObject(params)) {
      this.forward(pathName,params);
    } else {
      this.forward(pathName);
    }
    /**
    setTimeout(()=>{

      if (params.clearCache) {
        task.vue.clearCache();
      }

    })
     */

  },
  /**
   * @task task
   * @keepAlive 是否使用缓存
   * */
  _useCache(task,keepAlive){
    task.keepAlive=keepAlive;
  },
  /**
   * @description 回退到某一个页面
   * @param  model ={
     *            step, 指定回退 步数  正整数
     *            name, 指定回退到最近的指定名字的task
     *            step name 不能同时指定，如果同时指定会优先step
     *            clearCache true false 是否清缓存
     *          }
   * @param params 回退携带的参数
   *
   *
   * */
  backToPage(model = {}, params= {}) {
    var task;
    if (supreme.$.isEmptyObject(model) || (!model)) {
      this.back();
      return;
    }
    if (model.step > 0) {
      var type = "^[0-9]*[1-9][0-9]*$";
      var r = new RegExp(type);
      var flag = r.test(model.step);
      if (!flag) {
        supreme.showToast("step 参数必须是正整数")
        return;
      }
      task = taskMgr.backToTaskByStep(model.step);
    } else if (model.name) {
      task = taskMgr.backToTaskByName(model.name);
    }
    if (!task) {
      //supreme.showToast("无法回退因为没有浏览历史");
      this.forward(this.defaultJumpPath||'index');
      return;
    }

    if(task&&params.useCache!=undefined){
      this._useCache(task,params.useCache);
    }
    if (task&&model.clearCache) {
      task.vue.clearCache();
    }
    delete task.params.isForward;
    var p = supreme.$.extend({}, task.params, params);
    this.forward(task.pathName,p)
  },
  /**
   * @description 回退上个页面
   * @pamams.useCache 回退到的页面是否使用缓存
   * @params.clearCache 清除掉回退到页面的缓存
   * */
  back(params = {}) {
    if (!this.$router) {
      throw "use this function must has vue router module";
      return;
    }
    taskMgr.pop();
    var task = taskMgr.getLastTask();
    if(task&&params.useCache!=undefined){
      this._useCache(task,params.useCache);
    }
    if (task&&task.vue&&params.clearCache) {
      task.vue.clearCache();
    }
    if (!task) {
      //supreme.showToast("无法回退因为没有浏览历史");
      this.forward(this.defaultJumpPath||'index');
      return;
    }
    delete task.params.isForward;
    var p = supreme.$.extend({}, task.params, params);
    this.forward(task.pathName,p);
  },
  init(config){
    supreme.$.extend(this,config);
    if(!this.hasInitlized){
      this.hasInitlized=true;
      //处理浏览器自带的back forward 才会触发onpopstate 事件 history.pushState()或history.replaceState()不会触发popstate事件。只有在做出浏览器动作时，才会触发该事件
      var self=this;
      //解决浏览器回退
      window.onpopstate=function(stateEvent){
        //supreme.goto("index");
        var direction = taskMgr.getDirection();
        supreme._isPopState=true;
        /**
        if(direction=="back"){
          taskMgr.pop();
        }else{
          if(!getQueryString("url_gid")){
            return ;
          }else{
            var t = taskMgr.getTaskInAbandonTaskStack(getQueryString("url_gid"));
            taskMgr.addTask(t);
          }
        }
         */
        /**
         * 注意 state 在 safari 和ff 下的情况！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * */
        if(!stateEvent.state){
          taskMgr.clear();
          //window.location.reload();
          return ;
        }
        taskMgr.pop();
        var task = taskMgr.getLastTask();
        if(task){
          //目前只考虑浏览器回退的情况
          if(task.params){
            delete task.params.isForward;
          }
          supreme.forward(task.pathName,task.params);
        }else{
          supreme.forward(supreme.defaultJumpPath);
        }

      };
    }

  }

}
